import { useEffect } from "react";
import CourseListSection from "./components/course-list-section";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/store";
import { resetCourseDetail } from "@/store/slices/courseSlice";

function CourseManagement() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    return () => {
      dispatch(resetCourseDetail());
    };
  }, []);

  return (
    <div className="h-full flex flex-col gap-6">
      {/* Courses List - Takes remaining height */}
      <div className="h-full">
        <CourseListSection />
      </div>
    </div>
  );
}

export default CourseManagement;
